export default __webpack_public_path__ + "static/media/logo-md.4572208b.png";